import { Cake, Trophy } from 'lucide-react';
import { formatDateOnly } from '@hrms/ui';
import { tsr } from '../../lib/api.js';
import { HomeCard } from './HomeCard.js';
import { ListRow } from './ListRow.js';

const SHOWN = 3;

/**
 * "Birthday & Anniversary": the next few upcoming entries from the Celebrations feed (this week's
 * window), read-only — see celebrations.contract.ts's header for why there is no "send a wish" here.
 */
export function BirthdayAnniversary() {
  const query = tsr.celebrations.listCelebrations.useQuery({
    queryKey: ['celebrations', 'home', { range: 'week' }],
    queryData: { query: { range: 'week' } },
  });
  const items = (query.data?.status === 200 ? query.data.body.items : []).slice(0, SHOWN);

  return (
    <HomeCard
      title="Birthday & Anniversary"
      viewAll={{ to: '/engage/celebrations', label: 'View all' }}
      query={{ isPending: query.isPending, isError: query.isError }}
      isEmpty={items.length === 0}
      emptyTitle="No birthdays or anniversaries"
      emptyDescription="Upcoming celebrations this week will show here."
    >
      <ul className="flex flex-col gap-2">
        {items.map((entry) => (
          <ListRow
            key={`${entry.personId}-${entry.kind}`}
            icon={
              entry.kind === 'birthday' ? (
                <Cake className="size-4" />
              ) : (
                <Trophy className="size-4" />
              )
            }
            primary={entry.name}
            secondary={
              entry.kind === 'birthday'
                ? `Birthday · ${formatDateOnly(entry.occursOn)}`
                : `${entry.yearsOfService}-yr anniversary · ${formatDateOnly(entry.occursOn)}`
            }
          />
        ))}
      </ul>
    </HomeCard>
  );
}
